module.exports = __webpack_public_path__ + "static/media/pizza-maker.646fa56e.jpg";